export default {
  getEbookCover: (title = 'Cover coming soon', coverUrl) => {
    if (coverUrl) {
      return coverUrl
    } else {
      return `https://via.placeholder.com/300/19AAD1/FFFFFF?text=${title}`
    }
  }
}
